<div class="container-fluid">
  <page-header-search [isSearchInput]="false" [pageTitleValue]="'Emergency Card'"></page-header-search>
  <div class="card mb-4">
    <div class="card-body">
      <div class="row" [formGroup]="emergencyCardFrom">

        <div class="col-md-4 mb-3">
          <input type="number" class="form-control" formControlName="numbers" placeholder="Number of emergency cards"
            [maxLength]="3" [min]="1" [max]="500">
          <p class="text-danger" *ngIf="emergencyCardFrom.controls.numbers.value > 500">
            Maximum number of emergency cards is 500
           </p>
        </div>
        <div class="col mb-3 text-md-left text-right">
          <button type="button" class="btn btn-primary" (click)="generateEmergencyCard()"
            [disabled]="emergencyCardFrom.invalid">Generate Emergency Cards</button>
        </div>
      </div>
    </div>
  </div>
</div>